import React, { useEffect, useState } from "react";
import OtherMembersList from "./OtherMembersList.js";
import PlayerMemberList from "./PlayerMemberList.js";
import {
  collectMembersAndPositions,
  teamRosterDataCaller,
} from "../availability/2022/availabilityHelper.js";

const EventRoster = ({
  initialTeam,
  homeTeam,
  awayTeam,
  admin,
  childrenAndMember,
}) => {
  const team = initialTeam === "homeTeam" ? homeTeam : awayTeam;
  const { roster_print: printAble } = team._links;
  const [players, setPlayers] = useState([[], []]);
  const [coach, setCoach] = useState([]);

  useEffect(async () => {
    setPlayers(await collectMembersAndPositions(team, "player"));
    setCoach(await teamRosterDataCaller(team, "coach"));
  }, []);

  return (
    <div className="mt-4">
      <PlayerMemberList
        admin={admin}
        type={"players"}
        members={players}
        printAble={printAble?.href}
        childrenAndMember={childrenAndMember}
      />
      <OtherMembersList
        admin={admin}
        type={"coaches"}
        members={coach}
        childrenAndMember={childrenAndMember}
      />
    </div>
  );
};

export default EventRoster;
